import * as React from 'react';
import FullScreenLayout from '../full_screen_layout';
import { getLogoutUrl } from '../../utils/identity_helper';
import track from '../../utils/track';
import Button from '@doordash/component-button';
import { TeamNotFoundEvents } from '../../constants/events';
export var TeamNotFound = function () {
    React.useEffect(function () {
        track(TeamNotFoundEvents.VIEW_EMAIL_NOT_FOUND_PAGE);
    }, []);
    var handleClick = function () {
        var logoutUrl = getLogoutUrl();
        window.location.href = logoutUrl;
    };
    return (React.createElement(FullScreenLayout, null,
        React.createElement("h1", null, "Please Use Your Company Email"),
        React.createElement("p", null, "We cannot find an invite for the logged in account. To join your company on DoorDash, please log in with your company email address."),
        React.createElement(Button, { onClick: handleClick, size: Button.Sizes.Medium }, "Log Out to Switch Accounts")));
};
export default TeamNotFound;
